import React from 'react'
import {ReactComponent as Calender} from "../../../asset/icons/calender_gray_s.svg";
import ex_img from "../../../asset/image/ex_img_4.png";
import {ReactComponent as Logo} from "../../../asset/icons/amazon_logo_wob_lg.svg";
import {ReactComponent as Share} from "../../../asset/icons/share_white.svg";
import {ReactComponent as Eye} from "../../../asset/icons/eye_white.svg";

export default function ProductCard() {
  return (
    <div className="card-main">
      <div className="product-lg-card-container">
        <div className="card-header" style={{backgroundImage: `url(${ex_img})`}}>
          <div className="card-buttons">
            <button className="sm-button"><Eye/></button>
            <button className="sm-button"><Share/></button>
          </div>
          <div className="logo-cv">
            <Logo/>
          </div>
          <div className="card-content">
            <h2>نام محصول یا خدمت</h2>
            <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.</p>
            <div className="card-date">
              <div>
                <Calender/>
                <div>4/25/2021</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
